import { Fragment, type CSSProperties } from 'react'
import { Reveal } from './Reveal'
import { cn } from '../../lib/cn'

const WORD_STAGGER_MS = 45

function RiseWords({ text, from }: { text: string; from: number }) {
  return (
    <>
      {text.split(' ').map((word, i) => (
        <Fragment key={`${word}-${i}`}>
          {i > 0 ? ' ' : null}
          <span className="lp-word" style={{ '--lp-word-d': `${(from + i) * WORD_STAGGER_MS}ms` } as CSSProperties}>{word}</span>
        </Fragment>
      ))}
    </>
  )
}

/** The one section header every marketing section uses: eyebrow pill, two-line h2, optional sub. */
export function LpSectionHeader({ eyebrow, eyebrowTone, line1, line2, sub, align = 'left', className }: {
  eyebrow?: string
  eyebrowTone?: 'volt'
  line1: string
  line2?: string
  sub?: string
  align?: 'left' | 'center'
  className?: string
}) {
  const line1Words = line1.split(' ').length
  return (
    <Reveal className={cn('space-y-5', align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl', className)}>
      {eyebrow ? <span className="lp-eyebrow" data-tone={eyebrowTone}>{eyebrow}</span> : null}
      <h2 className="lp-h2 lp-headline">
        <span><RiseWords text={line1} from={0} /></span>
        {line2 ? <span className="lp-second-line"><RiseWords text={line2} from={line1Words} /></span> : null}
      </h2>
      {sub ? <p className={cn('lp-sub lp-body-lg max-w-2xl text-muted-foreground', align === 'center' && 'mx-auto')}>{sub}</p> : null}
    </Reveal>
  )
}
